import { useGetAdminAlertsQuery } from "../../../features/api/adminApiSlice";
import { FiBell } from "react-icons/fi";
import "./badge.scss";
import { useNavigate } from "react-router-dom";

const AdminAlertsBadge = () => {
  const navigate = useNavigate();
  const { data: alerts = [] } = useGetAdminAlertsQuery();

  // Count unread alerts
  const unreadCount = alerts.filter((alert) => !alert.read).length;

  return (
    <div className="admin-alerts-badge">
      <span className="icon" onClick={() => navigate("/admin/alerts")}>
        <FiBell />
      </span>
      {unreadCount > 0 && <span className="badge">{unreadCount}</span>}
    </div>
  );
};

export default AdminAlertsBadge;
